<script>
import TaxReturnTableRow from "@/components/accountants/tax_return/table/TaxReturnTableRow.vue";
import TaxReturnTable from "@/components/accountants/tax_return/table/TaxReturnTable.vue";
import TaxReturnTableHeader from "@/components/accountants/tax_return/table/TaxReturnTableHeader.vue";
import TaxReturnTableInput from "@/components/accountants/tax_return/table/TaxReturnTableInput.vue";

export default {
  name: "TaxReturnMaterialActiveSection",
  components: {TaxReturnTableInput, TaxReturnTableHeader, TaxReturnTable, TaxReturnTableRow},
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <TaxReturnTable>
    <template v-slot:header>
      <tr>
        <th>
          <translate>Beschrijving</translate>
        </th>

        <th>
          <translate>Originele kost van aanschaf</translate>
        </th>

        <th>
          <translate>Restwaarde</translate>
        </th>
      </tr>
    </template>

    <template v-slot:body>
      <tr>
        <td scope="row">
          {{ $gettext('(Bedrijfs)gebouwen en terreinen') }}
        </td>

        <td>
          <TaxReturnTableInput v-model="data.edit.balance_active_material_real_estate_original_cost"
                               :calculated-value="data.calculated.balance_active_material_real_estate_original_cost"/>
        </td>

        <td>
          <TaxReturnTableInput v-model="data.edit.balance_active_material_real_estate_remaining"
                               :calculated-value="data.calculated.balance_active_material_real_estate_remaining"/>
        </td>
      </tr>

      <tr>
        <td scope="row">
          {{ $gettext('Machines en installaties') }}
        </td>

        <td>
          <TaxReturnTableInput v-model="data.edit.balance_active_material_installations_original_cost"
                               :calculated-value="data.calculated.balance_active_material_installations_original_cost"/>
        </td>

        <td>
          <TaxReturnTableInput v-model="data.edit.balance_active_material_installations_remaining"
                               :calculated-value="data.calculated.balance_active_material_installations_remaining"/>
        </td>
      </tr>

      <tr>
        <td scope="row">
          {{ $gettext('Overige materiele vaste activa') }}
        </td>

        <td>
          <TaxReturnTableInput v-model="data.edit.balance_active_material_materials_original_cost"
                               :calculated-value="data.calculated.balance_active_material_materials_original_cost"/>
        </td>

        <td>
          <TaxReturnTableInput v-model="data.edit.balance_active_material_materials_remaining"
                               :calculated-value="data.calculated.balance_active_material_materials_remaining"/>
        </td>
      </tr>
    </template>
  </TaxReturnTable>
</template>

<style scoped lang="scss">

</style>